import React from "react";

export default class extends React.Component {

    render() {
        const {field, config} = this.props;
        return <div className="pubhub-smartsheet-form-section">
            <h3 className="pubhub-smartsheet-form-section-title">{field.title}</h3>
            <p className="lead">
            </p>
        </div>

    }
}